<template>
	<div class="popup-end-game">
		<div class="bg"></div>
		<div class="content">
			<div class="title">{{ title | lang }}</div>
			
			<div class="rows">
				<div class="row">
					<div class="label">{{ 'killed_enemies' | lang }}</div>
					<div class="value">{{ killed_enemies }}</div>
				</div>
				<div class="row">
					<div class="label">{{ 'collected_emeralds' | lang }}</div>
					<div class="value">{{ collected_emeralds }}</div>
				</div>
				<div class="row">
					<div class="label">{{ 'completed_levels' | lang }}</div>
					<div class="value">{{ completed_levels }}/7</div>
				</div>
			</div>

			<div class="score">
				<div class="label">{{ 'final_score' | lang }}</div>
				<div class="value">{{ popup.final_score }}</div>
			</div>

			<div class="buttons">
				<ui-button class="button-new-game" v-hammer:tap="new_game">{{ 'new_game' | lang}}</ui-button>
				<ui-button class="button-menu" v-hammer:tap="menu">{{ 'back_to_home' | lang}}</ui-button>
			</div>

		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import UiButton from '@/components/ui/ui-button'
import Sounds from '@/js/sounds'

export default {
	name: 'popup-end-game',
	props: {
		popup: { default: null }
	},
	computed: {
		...mapGetters([ 'lang', 'game' ]),
		title() {
			if (this.popup.status === 'victory') return 'victory'
			return 'game_over'
		},
		killed_enemies() {
			if (this.game.stats.length > 0) {
				const stat = this.game.stats.find(s => s.slug === 'killed_enemies')
				if (stat) return stat.value
			}
			return 0
		},
		collected_emeralds() {
			if (this.game.stats.length > 0) {
				const stat = this.game.stats.find(s => s.slug === 'collected_emeralds')
				if (stat) return stat.value
			}
			return 0
		},
		completed_levels() {
			if (this.game.stats.length > 0) {
				const stat = this.game.stats.find(s => s.slug === 'completed_levels')
				if (stat !== undefined) {
					if (this.popup.status === 'victory') return stat.value + 1
					return stat.value
				}
			}
			return 0
		},
	},
	methods: {
		new_game() {
			this.$store.dispatch('restart_game')
			this.$emit('close')
		},
		menu() {
			this.$router.push({ name: 'home' })
			this.$emit('close')
		},
	},
	mounted() {
		if (this.popup.status === 'lose') Sounds.play('death')
	},
	components: { UiButton }
}
</script>

<style lang="stylus" scoped>
@import '../../../assets/css/variables'


.popup-end-game
	absolute 0
	color #fff
	flex center center
	text-align center
	.bg
		absolute 0
	.content
		// height 100%
		width calc(100% - 32px)
		max-width 400px
		margin 0 auto
		flex center center column
		transform translateY(-24px)
		font-size 4rem
		.title
			margin 0 0 80px 0
			font-size 8rem
			line-height 1em
			text-align center
		.rows
			width 100%
			margin 0 0 80px 0
			.row
				flex center center
				margin 0 0 16px 0
				&:last-child
					margin 0
				.label
					width 75%
					text-align left
				.value
					width 25%
					text-align right
		.score
			margin 0 0 80px 0
			.label
				width 100%
			.value
				width 100%
				font-size 8rem
		
		.buttons
			flex center center
			>>> .ui-button
				margin 0 16px
				

</style>
